export enum FilterValueKey {
    startDate = 'startDate',
    endDate = 'endDate',
    serviceId = 'serviceId',
    productIds = 'productIds',
    serviceOrderStatus = 'serviceOrderStatus',
    visibleColumns = 'visibleColumns',
    customerId = 'customerId',
    filterProductsInInterval = 'filterProductsInInterval',
}
